module.exports = __webpack_public_path__ + "3d4091783bf3383fffc3f6068d6a245a.jpg";